import React from 'react';
import { Link } from 'react-router-dom';
import './EventCard.css';

const EventCard = ({ event }) => {
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="event-card">
      {event.imageUrl && (
        <img src={event.imageUrl} alt={event.title} className="event-image" />
      )}
      <div className="event-content">
        <h3 className="event-title">{event.title}</h3>
        <p className="event-date">
          📅 {formatDate(event.date)}
        </p>
        <p className="event-time">
          🕐 {event.startTime} - {event.endTime}
        </p>
        <p className="event-location">
          📍 {event.location.address}, {event.location.city}
        </p>
        <span className="event-category">{event.category}</span>
        <Link to={`/events/${event.id}`} className="view-btn">
          View Details
        </Link>
      </div>
    </div>
  );
};

export default EventCard;